import { AppMenuItem, AppTheme, AppUXControl } from "../types/experience";
import { ViewRequest, request } from "./request";

interface ExperienceUnauthGetRequest {
  readonly identifier: string;
  readonly subdomain: string;
  readonly as_of_date?: string;
  readonly language?: string;
}

interface ExperienceUnauthGetResponse {
  readonly identifier?: string;
  readonly identifier_type?: "query" | "subdomain";
  readonly ux_controls: AppUXControl[];
  readonly theme: AppTheme;
  readonly app_experience_source: "app" | "adjudication";
}

interface ExperienceAuthGetRequest {
  readonly as_of_date?: string;
  readonly language?: string;
}

interface ExperienceAuthGetResponse {
  readonly identifier?: string;
  readonly identifier_type?: "query" | "subdomain";
  readonly ux_controls: (AppUXControl & { readonly app_experience_context_id: number })[];
  readonly menu_items: (AppMenuItem & { readonly app_experience_context_id: number })[];
  readonly theme?: AppTheme & { readonly app_experience_context_id: number };
  readonly app_experience_source: "app" | "adjudication";
}

export const getExperienceUnauthenticated = async (body: ExperienceUnauthGetRequest) => {
  return request<ExperienceUnauthGetRequest, ExperienceUnauthGetResponse>({
    endpoint: "/experience/app/get",
    body: body,
    api: "authnz",
  });
};

export const getExperienceAuthenticated = async (authToken: string, body?: ExperienceAuthGetRequest & Partial<ViewRequest>) => {
  return request<ExperienceAuthGetRequest, ExperienceAuthGetResponse>({
    endpoint: "/experience/app/get",
    body: { ...(body || {}) },
  }, authToken);
};
